import React, {PureComponent} from 'react';
import {observer, inject} from 'mobx-react';
import {Link} from 'react-router-dom';
import {PageWrapper} from 'components/PageWrapper';
import {InputText} from '../../../blocks/inputs/InputText';
import {FileInput} from '../../../blocks/inputs/FileInput';
import pdfIcon from 'images/pdfFile.svg';

@inject('clinicalNoteWritingTopicsStore')
@observer
class TopicForm extends PureComponent {
  handleChange = e => {
    const {clinicalNoteWritingTopicsStore} = this.props;

    if (e.target.name === 'file') {
      clinicalNoteWritingTopicsStore.handleChange({[e.target.name]: e.target.files[0]});
    } else {
      clinicalNoteWritingTopicsStore.handleChange({[e.target.name]: e.target.value});
    }
  };

  render() {
    const {clinicalNoteWritingTopicsStore, submit} = this.props;
    const {topic, errors} = clinicalNoteWritingTopicsStore;
    const isNew = !topic.id;

    return (
      <PageWrapper>
        <form className="simple-form" onSubmit={submit}>
          <h2>{isNew ? 'Add Topic' : 'Edit Topic'}</h2>
          <InputText
            label='Add a Title'
            placeholder='Add a Title'
            fullWidth={true}
            onChange={this.handleChange}
            value={topic.title}
            name='title'
            errorText={errors ? errors.title : ''}
          />
          <FileInput
            label='Add a PDF'
            placeholder='Add a PDF'
            fullWidth={true}
            onChange={this.handleChange}
            value={topic.file}
            name='file'
            type='file'
            accept='.pdf'
            errorText={errors ? errors.file : ''}
          />
          {(!!topic.file_url && !topic.file.name) && (
            <a
              href={`https://finalmedexamprep.ie${topic.file_url}`}
              target='_blank'
              style={{
                margin: '16px 0',
                alignSelf: 'flex-start'
              }}
            >
              <img src={pdfIcon} style={{width: '25px', height: '25px', marginRight: '16px'}} />PDF
            </a>
          )}
          {!!topic.file.name && (
            <a
              href={`https://finalmedexamprep.ie${topic.file.name}`}
              target='_blank'
              style={{
                margin: '16px 0',
                alignSelf: 'flex-start'
              }}
            >
              <img src={pdfIcon} style={{width: '25px', height: '25px', marginRight: '16px'}} />{topic.file.name}
            </a>
          )}
          <div className="row">
            <button className="btn-new-main" type="submit">{isNew ? 'Create' : 'Edit'}</button>
            <Link to={`/clinical-notes-writing/${topic.categoryId}/edit`} className="btn-new-white margin-left-20">Cancel</Link>
          </div>
        </form>
      </PageWrapper>
    );
  }
}

export default TopicForm;



// WEBPACK FOOTER //
// ./src/modules/admin/clinicalNoteWriting/components/TopicForm.js